// Full comprehensive services catalogue for TANSEEQ — grouped into 4 categories.
// Each service is rendered as a detailed panel (link + details inside) on the Services page.

export const SERVICE_GROUPS = [
  {
    id: "tax",
    icon: "receipt",
    label: { en: "Tax & FTA Services", ar: "الضرائب والوكيل الضريبي" },
    blurb: {
      en: "Full VAT (5%), Corporate Tax (9%) and Excise Tax coverage — registration, filing, refunds, deregistration and FTA representation.",
      ar: "تغطية كاملة لضريبة القيمة المضافة (5%) وضريبة الشركات (9%) والضريبة الانتقائية — تسجيل وإقرارات واسترداد وإلغاء وتمثيل أمام الهيئة.",
    },
    services: [
      {
        id: "vat-registration",
        title: { en: "VAT Registration (5%)", ar: "التسجيل في ضريبة القيمة المضافة (5%)" },
        summary: {
          en: "Mandatory and voluntary VAT registration with the FTA, including group registration and tax-record setup.",
          ar: "التسجيل الإلزامي والاختياري في ضريبة القيمة المضافة لدى الهيئة، بما في ذلك التسجيل الجماعي وإعداد السجل الضريبي.",
        },
        points: {
          en: ["Eligibility & threshold assessment (mandatory / voluntary)", "FTA account setup and TRN issuance", "VAT group registration where beneficial", "Document preparation and submission"],
          ar: ["تقييم الأهلية والحد الإلزامي/الاختياري", "إنشاء حساب الهيئة وإصدار الرقم الضريبي TRN", "التسجيل الجماعي عند الحاجة", "تجهيز المستندات والتقديم"],
        },
      },
      {
        id: "vat-returns",
        title: { en: "VAT Computation & Return Filing", ar: "احتساب وتقديم إقرارات ض.ق.م" },
        summary: {
          en: "Accurate VAT computation and periodic return preparation, review and on-time filing to keep you compliant.",
          ar: "احتساب دقيق لضريبة القيمة المضافة وإعداد ومراجعة الإقرارات الدورية وتقديمها في مواعيدها للحفاظ على الامتثال.",
        },
        points: {
          en: ["Output/input VAT computation from transactions", "Zero-rated, exempt and reverse-charge treatment", "Return preparation, review and submission", "Reconciliation with the accounting records"],
          ar: ["احتساب ضريبة المخرجات والمدخلات من العمليات", "معالجة المعفاة وصفرية النسبة والاحتساب العكسي", "إعداد ومراجعة وتقديم الإقرار", "المطابقة مع السجلات المحاسبية"],
        },
      },
      {
        id: "vat-refund",
        title: { en: "VAT Refund Services", ar: "استرداد ضريبة القيمة المضافة" },
        summary: {
          en: "End-to-end VAT refund claims with the supporting data and evidence the FTA requires.",
          ar: "إدارة كاملة لطلبات استرداد ضريبة القيمة المضافة مع البيانات والمستندات التي تطلبها الهيئة.",
        },
        points: {
          en: ["Refund eligibility review", "Supporting schedules and evidence file", "Claim submission and FTA follow-up", "Response to FTA queries on the refund"],
          ar: ["مراجعة أحقية الاسترداد", "إعداد الجداول والمستندات الداعمة", "تقديم الطلب ومتابعة الهيئة", "الرد على استفسارات الهيئة بشأن الاسترداد"],
        },
      },
      {
        id: "vat-deregistration",
        title: { en: "VAT Deregistration & Cancellation", ar: "إلغاء التسجيل الضريبي" },
        summary: {
          en: "Correct and timely VAT deregistration to avoid penalties when you no longer meet the conditions.",
          ar: "إلغاء التسجيل الضريبي بشكل صحيح وفي الوقت المناسب لتجنّب الغرامات عند انتفاء الشروط.",
        },
        points: {
          en: ["Deregistration eligibility check", "Final return preparation and settlement", "Application submission and closure", "Guidance to avoid late-deregistration penalties"],
          ar: ["التحقق من أهلية إلغاء التسجيل", "إعداد الإقرار النهائي والتسوية", "تقديم الطلب وإتمام الإغلاق", "إرشادات لتجنّب غرامة التأخر في الإلغاء"],
        },
      },
      {
        id: "corporate-tax",
        title: { en: "Corporate Tax (9%)", ar: "ضريبة الشركات (9%)" },
        summary: {
          en: "Corporate Tax registration, computation, return filing and Small Business Relief assessment — 0% up to AED 375,000 and 9% above.",
          ar: "التسجيل في ضريبة الشركات والاحتساب وتقديم الإقرار وتقييم تسهيلات الأعمال الصغيرة — 0% حتى 375,000 درهم و9% لما يزيد عنها.",
        },
        points: {
          en: ["Corporate Tax registration and status review", "Taxable income computation and return filing", "Small Business Relief eligibility assessment", "Deregistration and closing of tax periods"],
          ar: ["التسجيل في ضريبة الشركات ومراجعة الحالة", "احتساب الدخل الخاضع وتقديم الإقرار", "تقييم الأهلية لتسهيلات الأعمال الصغيرة", "إلغاء التسجيل وإغلاق الفترات الضريبية"],
        },
      },
      {
        id: "excise-tax",
        title: { en: "Excise Tax Services", ar: "خدمات الضريبة الانتقائية" },
        summary: {
          en: "Complete Excise Tax handling — registration, product registration in the FTA system, import declarations and return filing.",
          ar: "إدارة كاملة للضريبة الانتقائية — التسجيل، وتسجيل المنتجات في نظام الهيئة، وطلبات الاستيراد، وتقديم الإقرارات.",
        },
        points: {
          en: ["Excise Tax registration with the FTA", "Excise product registration in the FTA product list", "Import declarations and clearance support", "Excise return preparation, filing and closing"],
          ar: ["التسجيل في الضريبة الانتقائية لدى الهيئة", "تسجيل المنتجات في قائمة منتجات الهيئة", "تقديم طلبات الاستيراد ودعم التخليص", "إعداد وتقديم وإغلاق إقرارات الضريبة الانتقائية"],
        },
      },
      {
        id: "tax-agent",
        title: { en: "Certified Tax Agent (FTA)", ar: "الوكيل الضريبي المعتمد" },
        summary: {
          en: "As an accredited Tax Agent (FTA No. 30003883) we represent you directly before the Federal Tax Authority and manage your tax affairs end-to-end.",
          ar: "بصفتنا وكيلاً ضريبياً معتمداً (رقم الهيئة 30003883) نمثّلك مباشرةً أمام الهيئة الاتحادية للضرائب وندير شؤونك الضريبية بالكامل.",
        },
        points: {
          en: ["Direct representation before the FTA on your behalf", "Filing your tax returns and handling notices", "Managing and resolving tax issues as they arise", "Ongoing follow-up of your tax files and decisions"],
          ar: ["التمثيل المباشر أمام الهيئة نيابةً عنك", "تقديم إقراراتك الضريبية والتعامل مع الإشعارات", "إدارة وحل المشكلات الضريبية عند حدوثها", "المتابعة المستمرة لملفاتك الضريبية والقرارات المتعلقة بها"],
        },
      },
      {
        id: "tax-audit",
        title: { en: "Tax Audit Support & Consultancy", ar: "دعم التدقيق الضريبي والاستشارات" },
        summary: {
          en: "Preparation and representation for FTA tax audits, plus practical tax advisory that saves you time and stress.",
          ar: "التجهيز والتمثيل في التدقيق الضريبي للهيئة، إضافةً إلى استشارات ضريبية عملية توفّر عليك الوقت والجهد.",
        },
        points: {
          en: ["Tax audit readiness and document organization", "Reconciliations and evidence preparation", "Penalty review and available relief/waiver routes", "Reconsideration and voluntary disclosure support"],
          ar: ["الجاهزية للتدقيق الضريبي وتنظيم المستندات", "التسويات وتجهيز الأدلة", "مراجعة الغرامات ومسارات الإعفاء المتاحة", "دعم إعادة النظر والإفصاح الطوعي"],
        },
      },
      {
        id: "einvoicing",
        title: { en: "eInvoicing Readiness", ar: "الاستعداد للفوترة الإلكترونية" },
        summary: {
          en: "Readiness assessment for the UAE eInvoicing rollout — data quality, master data and system mapping before mandatory dates.",
          ar: "تقييم الجاهزية لتطبيق الفوترة الإلكترونية في الإمارات — جودة البيانات والبيانات الرئيسية وربط الأنظمة قبل المواعيد الإلزامية.",
        },
        points: {
          en: ["Readiness assessment and gap list", "Invoice and master-data cleanup", "Process mapping for ASP onboarding", "Accounting/ERP data readiness"],
          ar: ["تقييم الجاهزية وقائمة الفجوات", "تنظيف بيانات الفواتير والبيانات الرئيسية", "رسم العمليات لربط مزوّد الخدمة المعتمد", "جاهزية بيانات المحاسبة/تخطيط الموارد"],
        },
      },
    ],
  },
  {
    id: "audit",
    icon: "search",
    label: { en: "Audit & Assurance", ar: "التدقيق والمراجعة" },
    blurb: {
      en: "Independent internal and external audits and accounting advisory reports that build trust with banks, investors and authorities.",
      ar: "تدقيق داخلي وخارجي مستقل وتقارير استشارية محاسبية تبني الثقة مع البنوك والمستثمرين والجهات الرسمية.",
    },
    services: [
      {
        id: "external-audit",
        title: { en: "External Audit", ar: "التدقيق الخارجي" },
        summary: {
          en: "Independent external audit of financial statements in line with recognized standards, for stakeholders and authorities.",
          ar: "تدقيق خارجي مستقل للقوائم المالية وفق المعايير المعتمدة، لأصحاب المصلحة والجهات الرسمية.",
        },
        points: {
          en: ["Financial statement audit", "Balance sheet and P&L review", "Audit report for banks, investors and authorities", "Compliance with applicable standards"],
          ar: ["تدقيق القوائم المالية", "مراجعة الميزانية وقائمة الأرباح والخسائر", "تقرير تدقيق للبنوك والمستثمرين والجهات الرسمية", "الامتثال للمعايير المعمول بها"],
        },
      },
      {
        id: "internal-audit",
        title: { en: "Internal Audit", ar: "التدقيق الداخلي" },
        summary: {
          en: "Internal audit of controls and processes to reduce risk and strengthen governance and efficiency.",
          ar: "تدقيق داخلي للضوابط والإجراءات لتقليل المخاطر وتعزيز الحوكمة والكفاءة.",
        },
        points: {
          en: ["Internal control review and risk assessment", "Process and compliance testing", "Findings and improvement recommendations", "Follow-up on remediation"],
          ar: ["مراجعة الضوابط الداخلية وتقييم المخاطر", "اختبار العمليات والامتثال", "النتائج وتوصيات التحسين", "متابعة الإجراءات التصحيحية"],
        },
      },
      {
        id: "advisory-reports",
        title: { en: "Accounting Advisory Reports", ar: "التقارير الاستشارية المحاسبية" },
        summary: {
          en: "Tailored advisory reports that turn your numbers into clear decisions for management and stakeholders.",
          ar: "تقارير استشارية مخصّصة تحوّل أرقامك إلى قرارات واضحة للإدارة وأصحاب المصلحة.",
        },
        points: {
          en: ["Management and performance reporting", "Financial analysis and recommendations", "Reports for financing and investment", "Custom stakeholder reporting"],
          ar: ["تقارير الإدارة والأداء", "التحليل المالي والتوصيات", "تقارير لأغراض التمويل والاستثمار", "تقارير مخصّصة لأصحاب المصلحة"],
        },
      },
    ],
  },
  {
    id: "accounting",
    icon: "book",
    label: { en: "Accounting & Reporting", ar: "المحاسبة والتقارير" },
    blurb: {
      en: "Bookkeeping, financial statements, company revaluation and feasibility studies — the reliable foundation for tax and decisions.",
      ar: "مسك الدفاتر والقوائم المالية وإعادة تقييم الشركات ودراسات الجدوى — الأساس الموثوق للضرائب والقرارات.",
    },
    services: [
      {
        id: "bookkeeping",
        title: { en: "Bookkeeping Services", ar: "خدمات إمساك الدفاتر المحاسبية" },
        summary: {
          en: "Day-to-day bookkeeping, ledgers and reconciliations that keep your records accurate and tax-ready.",
          ar: "مسك دفاتر يومي وقيود وتسويات تحافظ على دقة سجلاتك وجاهزيتها للضرائب.",
        },
        points: {
          en: ["Monthly/quarterly bookkeeping and ledgers", "Bank, customer and supplier reconciliations", "Backlog accounting and clean-up", "Schedules supporting VAT and Corporate Tax"],
          ar: ["مسك الدفاتر والقيود شهرياً/ربع سنوي", "تسويات البنوك والعملاء والموردين", "معالجة الحسابات المتأخرة وتنظيفها", "جداول مساندة لض.ق.م وضريبة الشركات"],
        },
      },
      {
        id: "financial-reporting",
        title: { en: "Financial Statements & Reporting", ar: "القوائم والتقارير المالية" },
        summary: {
          en: "Structured financial statements and management reports built from organized accounting records.",
          ar: "قوائم مالية منظمة وتقارير إدارية مبنية على سجلات محاسبية مرتبة.",
        },
        points: {
          en: ["Income statement and balance sheet", "Cash flow and management schedules", "Customer, supplier and account statements", "Period-end closing support"],
          ar: ["قائمة الدخل والميزانية العمومية", "التدفقات النقدية والجداول الإدارية", "كشوف العملاء والموردين والحسابات", "دعم الإقفال في نهاية الفترة"],
        },
      },
      {
        id: "revaluation",
        title: { en: "Company Revaluation Services", ar: "خدمات إعادة تقييم الشركات" },
        summary: {
          en: "Revaluation of your company's assets and worth for financing, restructuring, entry/exit of partners or sale.",
          ar: "إعادة تقييم أصول الشركة وقيمتها لأغراض التمويل أو إعادة الهيكلة أو دخول/خروج الشركاء أو البيع.",
        },
        points: {
          en: ["Asset and business valuation", "Support for partner entry/exit and restructuring", "Valuation for financing or sale", "Clear valuation report"],
          ar: ["تقييم الأصول وقيمة النشاط", "دعم دخول/خروج الشركاء وإعادة الهيكلة", "التقييم لأغراض التمويل أو البيع", "تقرير تقييم واضح"],
        },
      },
      {
        id: "feasibility",
        title: { en: "Feasibility Study Services", ar: "خدمات دراسات الجدوى" },
        summary: {
          en: "Practical feasibility studies that test the numbers before you invest, expand or launch a new venture.",
          ar: "دراسات جدوى عملية تختبر الأرقام قبل الاستثمار أو التوسّع أو إطلاق مشروع جديد.",
        },
        points: {
          en: ["Market and financial feasibility", "Cost, revenue and break-even projections", "Funding and investment scenarios", "Clear go / no-go recommendation"],
          ar: ["الجدوى السوقية والمالية", "توقعات التكاليف والإيرادات ونقطة التعادل", "سيناريوهات التمويل والاستثمار", "توصية واضحة بالمضي أو التوقف"],
        },
      },
      {
        id: "payroll",
        title: { en: "Payroll Support", ar: "دعم الرواتب" },
        summary: {
          en: "Payroll processing integrated with your accounting so costs, liabilities and WPS payments are recorded correctly.",
          ar: "معالجة الرواتب مدمجة مع المحاسبة لتظهر التكاليف والالتزامات ومدفوعات نظام حماية الأجور بشكل صحيح.",
        },
        points: {
          en: ["Payroll schedules and accounting entries", "Salary accrual and payment reconciliation", "WPS-aligned processing", "Management reporting support"],
          ar: ["جداول الرواتب والقيود المحاسبية", "استحقاق الرواتب وتسوية المدفوعات", "معالجة متوافقة مع نظام حماية الأجور", "دعم التقارير الإدارية"],
        },
      },
    ],
  },
  {
    id: "setup",
    icon: "building",
    label: { en: "Company Setup & PRO", ar: "تأسيس الشركات والخدمات الإدارية" },
    blurb: {
      en: "Mainland, Free Zone, e-commerce and KSA company formation, license amendments, liquidation, visas and bank accounts — one desk for it all.",
      ar: "تأسيس شركات محلية وفي المناطق الحرة والتجارة الإلكترونية وفي السعودية، وتعديل الرخص والتصفية والتأشيرات والحسابات البنكية — كل ذلك من مكان واحد.",
    },
    services: [
      {
        id: "mainland",
        title: { en: "Mainland Company Formation", ar: "تأسيس الشركات المحلية في الإمارات" },
        summary: {
          en: "Set up your mainland company in the UAE with the right legal structure, licensing and approvals.",
          ar: "تأسيس شركتك المحلية في الإمارات بالهيكل القانوني والرخصة والموافقات المناسبة.",
        },
        points: {
          en: ["Activity selection and legal structure", "Trade name reservation and initial approval", "Licensing and government approvals", "MOA and establishment card"],
          ar: ["اختيار النشاط والهيكل القانوني", "حجز الاسم التجاري والموافقة المبدئية", "الترخيص والموافقات الحكومية", "عقد التأسيس وبطاقة المنشأة"],
        },
      },
      {
        id: "freezone",
        title: { en: "Free Zone Company Formation", ar: "تأسيس الشركات في المنطقة الحرة" },
        summary: {
          en: "Free zone setup with 100% ownership options, choosing the right free zone for your activity and budget.",
          ar: "التأسيس في المنطقة الحرة مع خيارات التملّك الكامل، واختيار المنطقة الأنسب لنشاطك وميزانيتك.",
        },
        points: {
          en: ["Free zone selection and package advice", "License application and approvals", "Office/flexi-desk arrangement", "Immigration and establishment setup"],
          ar: ["اختيار المنطقة الحرة ونصح الباقة", "تقديم طلب الرخصة والموافقات", "ترتيب المكتب/المكتب المرن", "إعداد الإقامة والمنشأة"],
        },
      },
      {
        id: "ecommerce-license",
        title: { en: "E-commerce License Setup & Renewal", ar: "تأسيس وتجديد رخص الشركات الإلكترونية" },
        summary: {
          en: "Launch and renew your e-commerce license so you can sell online legally in the UAE.",
          ar: "إطلاق وتجديد رخصة التجارة الإلكترونية لتبيع عبر الإنترنت بشكل قانوني في الإمارات.",
        },
        points: {
          en: ["E-commerce activity licensing", "Mainland or free zone options", "License renewal and amendments", "Payment gateway and compliance guidance"],
          ar: ["ترخيص أنشطة التجارة الإلكترونية", "خيارات محلية أو منطقة حرة", "تجديد الرخصة والتعديلات", "إرشادات بوابات الدفع والامتثال"],
        },
      },
      {
        id: "license-amendment",
        title: { en: "Business License Amendment", ar: "تعديل رخص الأعمال" },
        summary: {
          en: "Amend your trade license — activities, ownership, name, address or legal form — quickly and correctly.",
          ar: "تعديل رخصتك التجارية — الأنشطة أو الملكية أو الاسم أو العنوان أو الشكل القانوني — بسرعة ودقة.",
        },
        points: {
          en: ["Add/remove business activities", "Ownership and partner changes", "Trade name and address updates", "Legal form conversion"],
          ar: ["إضافة/إزالة الأنشطة التجارية", "تغييرات الملكية والشركاء", "تحديث الاسم التجاري والعنوان", "تحويل الشكل القانوني"],
        },
      },
      {
        id: "liquidation",
        title: { en: "Company Liquidation", ar: "تصفية الشركات في الإمارات" },
        summary: {
          en: "Proper company liquidation and closure — clearances, liquidator report and cancellation of the license.",
          ar: "تصفية وإغلاق الشركات بشكل نظامي — المخالصات وتقرير المصفّي وإلغاء الرخصة.",
        },
        points: {
          en: ["Liquidation planning and clearances", "Liquidator report preparation", "Settlement of tax and liabilities", "Final license cancellation"],
          ar: ["تخطيط التصفية والمخالصات", "إعداد تقرير المصفّي", "تسوية الضرائب والالتزامات", "إلغاء الرخصة نهائياً"],
        },
      },
      {
        id: "visa",
        title: { en: "Visa & PRO Services", ar: "خدمات التأشيرات والإجراءات الحكومية" },
        summary: {
          en: "Investor, partner and employee visas plus PRO government-liaison services handled for you.",
          ar: "تأشيرات المستثمر والشريك والموظفين إضافةً إلى خدمات العلاقات الحكومية (PRO) نتولّاها عنك.",
        },
        points: {
          en: ["Investor, partner and employment visas", "Establishment card and quota", "Medical, Emirates ID and stamping coordination", "PRO government liaison"],
          ar: ["تأشيرات المستثمر والشريك والعمل", "بطاقة المنشأة والحصص", "تنسيق الفحص الطبي والهوية والختم", "خدمات العلاقات الحكومية PRO"],
        },
      },
      {
        id: "bank-account",
        title: { en: "Corporate Bank Account Opening", ar: "فتح حسابات بنكية للشركات" },
        summary: {
          en: "Guidance and document preparation to open a corporate bank account with UAE banks smoothly.",
          ar: "إرشاد وتجهيز المستندات لفتح حساب بنكي للشركات لدى بنوك الإمارات بسلاسة.",
        },
        points: {
          en: ["Bank selection guidance", "KYC and document preparation", "Application coordination and follow-up", "Support with compliance requirements"],
          ar: ["إرشاد اختيار البنك", "تجهيز مستندات اعرف عميلك KYC", "تنسيق الطلب والمتابعة", "دعم متطلبات الامتثال"],
        },
      },
      {
        id: "ksa",
        title: { en: "Company Formation in Saudi Arabia", ar: "تأسيس الشركات في المملكة العربية السعودية" },
        summary: {
          en: "Expand to Saudi Arabia with company formation and licensing support across the Kingdom.",
          ar: "التوسّع إلى المملكة العربية السعودية بدعم كامل لتأسيس الشركات والترخيص داخل المملكة.",
        },
        points: {
          en: ["MISA investment license", "Commercial registration (CR)", "Legal structure and activity setup"],
          ar: ["رخصة الاستثمار (وزارة الاستثمار)", "السجل التجاري", "الهيكل القانوني وإعداد النشاط"],
        },
      },
    ],
  },
];

// Flat list used by the home preview
export const ALL_SERVICE_COUNT = SERVICE_GROUPS.reduce((n, g) => n + g.services.length, 0);

// ---------------- Packages ----------------
export const PRICE_NOTE = {
  en: "Pricing is determined based on the volume of documentary work.",
  ar: "تُحدَّد الأسعار بناءً على حجم العمل المستندي.",
};

export const FEATURES = {
  sales_posting: { en: "Sales invoices posting", ar: "ترحيل فواتير المبيعات" },
  purchase_posting: { en: "Purchase invoices posting", ar: "ترحيل فواتير المشتريات" },
  expense_posting: { en: "Expense invoices posting", ar: "ترحيل فواتير المصروفات" },
  bank_rec: { en: "Bank & credit card reconciliation", ar: "تسوية البنوك وبطاقات الائتمان" },
  journals: { en: "Journals posting", ar: "ترحيل القيود اليومية" },
  month_end: { en: "Month-end entries posting", ar: "ترحيل قيود نهاية الشهر" },
  pl_report: { en: "Profit & Loss report", ar: "تقرير الأرباح والخسائر" },
  bs_report: { en: "Balance Sheet report", ar: "تقرير الميزانية العمومية" },
  cashflow_report: { en: "Cash Flow report", ar: "تقرير التدفقات النقدية" },
  vat_report: { en: "VAT report", ar: "تقرير ضريبة القيمة المضافة" },
  schedules_bs: { en: "Schedules to Balance Sheet", ar: "جداول مساندة للميزانية" },
  mis_reports: { en: "MIS reports", ar: "تقارير المعلومات الإدارية (MIS)" },
  tax_advice: { en: "Tax advice", ar: "استشارات ضريبية" },
  vat_registration: { en: "VAT registration", ar: "التسجيل في ض.ق.م" },
  vat_returns: { en: "VAT returns submission", ar: "تقديم إقرارات ض.ق.م" },
  ct_consultation: { en: "Corporate Tax consultation", ar: "استشارة ضريبة الشركات" },
  ct_registration: { en: "Corporate Tax registration", ar: "التسجيل في ضريبة الشركات" },
  ct_filing: { en: "Corporate Tax filing", ar: "تقديم إقرار ضريبة الشركات" },
  annual_audit: { en: "Annual audit report", ar: "تقرير التدقيق السنوي" },
  phone_support: { en: "Phone & online support", ar: "دعم هاتفي وعبر الإنترنت" },
  ongoing_support: { en: "Ongoing support & advice", ar: "دعم ومشورة مستمرة" },
  monthly_meetings: { en: "Monthly meetings", ar: "اجتماعات شهرية" },
  free_setup: { en: "Free setup & implementation (Chart of Accounts, software)", ar: "إعداد وتنفيذ مجاني (شجرة الحسابات والبرنامج)" },
  dedicated_accountant: { en: "Dedicated accountant available at all times", ar: "محاسب مخصّص متاح في جميع الأوقات" },
  payroll_4: { en: "Payroll up to 4 employees", ar: "رواتب حتى 4 موظفين" },
  payroll_mgmt: { en: "Payroll management", ar: "إدارة الرواتب" },
  receivable_mgmt: { en: "Receivables management", ar: "إدارة المدينين" },
  payable_mgmt: { en: "Payables management", ar: "إدارة الدائنين" },
};

const G = {
  bookkeeping: { en: "Accounting & Bookkeeping", ar: "المحاسبة ومسك الدفاتر" },
  reporting: { en: "Monthly Reporting", ar: "التقارير الشهرية" },
  compliance: { en: "Compliance", ar: "الامتثال" },
  support: { en: "Support", ar: "الدعم" },
  addons: { en: "Additional Services", ar: "خدمات إضافية" },
};

const CORE_BOOKKEEPING = ["sales_posting", "purchase_posting", "expense_posting", "bank_rec", "journals", "month_end"];
const CORE_COMPLIANCE = ["tax_advice", "vat_registration", "vat_returns", "ct_consultation", "ct_registration", "ct_filing"];

export const PACKAGES = [
  {
    id: "p1",
    name: { en: "Package 1", ar: "الباقة الأولى" },
    tier: { en: "Start-Up Companies", ar: "الشركات الناشئة" },
    popular: false,
    groups: [
      { title: G.bookkeeping, items: CORE_BOOKKEEPING },
      { title: G.reporting, items: ["pl_report", "bs_report", "cashflow_report", "vat_report", "schedules_bs"] },
      { title: G.compliance, items: ["tax_advice", "vat_returns", "ct_consultation", "ct_filing"] },
      { title: G.support, items: ["phone_support", "ongoing_support", "monthly_meetings", "free_setup"] },
    ],
  },
  {
    id: "p2",
    name: { en: "Package 2", ar: "الباقة الثانية" },
    tier: { en: "Mid-Size Companies", ar: "الشركات المتوسطة" },
    popular: true,
    groups: [
      { title: G.bookkeeping, items: CORE_BOOKKEEPING },
      { title: G.reporting, items: ["pl_report", "bs_report", "cashflow_report", "vat_report", "schedules_bs", "mis_reports"] },
      { title: G.compliance, items: CORE_COMPLIANCE },
      { title: G.support, items: ["phone_support", "ongoing_support", "monthly_meetings", "free_setup", "payroll_4"] },
    ],
  },
  {
    id: "p3",
    name: { en: "Package 3", ar: "الباقة الثالثة" },
    tier: { en: "Established Business", ar: "الأعمال القائمة" },
    popular: false,
    groups: [
      { title: G.bookkeeping, items: CORE_BOOKKEEPING },
      { title: G.reporting, items: ["pl_report", "bs_report", "cashflow_report", "vat_report", "schedules_bs", "mis_reports"] },
      { title: G.compliance, items: CORE_COMPLIANCE },
      { title: G.support, items: ["phone_support", "ongoing_support", "monthly_meetings", "free_setup", "dedicated_accountant"] },
    ],
  },
  {
    id: "p4",
    name: { en: "Package 4", ar: "الباقة الرابعة" },
    tier: { en: "Enterprise Business", ar: "المؤسسات الكبرى" },
    popular: false,
    groups: [
      { title: G.bookkeeping, items: CORE_BOOKKEEPING },
      { title: G.reporting, items: ["pl_report", "bs_report", "cashflow_report", "vat_report", "schedules_bs", "mis_reports"] },
      { title: G.compliance, items: [...CORE_COMPLIANCE, "annual_audit"] },
      { title: G.support, items: ["phone_support", "ongoing_support", "monthly_meetings", "free_setup", "dedicated_accountant"] },
      { title: G.addons, items: ["payroll_mgmt", "receivable_mgmt", "payable_mgmt"] },
    ],
  },
];
